import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#F8FAFC', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      padding: '20px'
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .login-card {
          animation: slideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          background: #FFFFFF;
          width: 100%;
          max-width: 440px;
          padding: 48px;
          border-radius: 32px;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.04);
          border: 1px solid #F1F5F9;
        }

        .input-group input {
          width: 100%;
          padding: 14px 16px;
          border-radius: 12px;
          border: 2px solid #F1F5F9;
          background: #F8FAFC;
          transition: all 0.2s;
          font-size: 15px;
          font-weight: 500;
          outline: none;
        }

        .input-group input:focus {
          border-color: #534AB7;
          background: #FFF;
          box-shadow: 0 0 0 4px rgba(83, 74, 183, 0.1);
        }

        .login-btn {
          width: 100%;
          padding: 16px;
          background: #534AB7;
          color: white;
          border: none;
          border-radius: 14px;
          font-weight: 700;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.2s;
          margin-top: 10px;
        }

        .login-btn:hover {
          background: #3C3489;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(83, 74, 183, 0.2);
        }

        .login-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
      `}</style>

      <div className="login-card">
        {/* Header / Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ 
            width: '64px', height: '64px', background: '#F0EFFF', 
            borderRadius: '20px', display: 'inline-flex', 
            alignItems: 'center', justifyContent: 'center', marginBottom: '20px' 
          }}>
            <img 
              src="/unilia_logo.png" 
              alt="Logo" 
              style={{ width: '40px', height: '40px', objectContain: 'contain' }}
            />
          </div>
          <h1 style={{ fontSize: '24px', fontWeight: 800, color: '#0F172A', letterSpacing: '-0.5px' }}>
            Welcome Back
          </h1>
          <p style={{ color: '#64748B', fontSize: '14px', marginTop: '4px', fontWeight: 500 }}>
            UNILIA-Laws Admin Portal
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div className="input-group">
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 700, color: '#475569', marginBottom: '8px', marginLeft: '4px' }}>
              Email Address
            </label>
            <input
              type="email"
              required
              placeholder="e.g. admin@unilia.ac.mw"
              value={form.email}
              onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
            />
          </div>

          <div className="input-group">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', marginLeft: '4px' }}>
              <label style={{ fontSize: '13px', fontWeight: 700, color: '#475569' }}>
                Password
              </label>
              <a href="#" style={{ fontSize: '12px', fontWeight: 700, color: '#534AB7', textDecoration: 'none' }}>
                Forgot?
              </a>
            </div>
            <input
              type="password"
              required
              placeholder="••••••••"
              value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
            />
          </div>

          <button type="submit" disabled={loading} className="login-btn">
            {loading ? 'Authenticating...' : 'Sign In to Portal'}
          </button>
        </form>

        {/* Footer */}
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          <p style={{ fontSize: '13px', color: '#94A3B8', fontWeight: 500 }}>
            Secure Timetable Management System <br/>
            Laws Campus
          </p>
        </div>
      </div>
    </div>
  );
}